import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../../axios";
import { Helmet } from "react-helmet";
import moment from "moment";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./Update.module.css";

import FormikControl from "../../../components/FormikControl/FormikControl";
import Button from "../../../components/Button/Button";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";

class Update extends Component {
  state = {
    data: null,
    isLoading: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { id } = this.props.match.params;

    axios
      .get(`/offers-interests/${id}`)
      .then((response) => {
        this.setState({
          data: {
            ...response.data,
            status: response.data.status.id.toString(),
          },
        });
      })
      .catch((error) => {
        if (error.response.data.code === 2001) {
          const errors = error.response.data.errors;
          toast.error(Object.values(errors[0])[0]);
        } else {
          toast.error(error.response.data.message);
        }
      });
  };

  render() {
    const { data } = this.state;

    const initialValues = {
      status: data ? data.status : "",
    };

    const validationSchema = Yup.object({
      status: Yup.mixed().required("Status is required"),
    });

    const onSubmit = (values) => {
      this.setState({ isLoading: true });

      axios
        .put(`/offers-interests/${data.id}`, values)
        .then((response) => {
          toast.success(response.data.message);
        })
        .catch((error) => {
          if (error.response.data.code === 2001) {
            const errors = error.response.data.errors;
            toast.error(Object.values(errors[0])[0]);
          } else {
            toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    };

    const statusOptions = [
      { value: "0", label: "Pending" },
      { value: "1", label: "Closed" },
    ];

    return (
      <div className={styles.Create}>
        <Helmet>
          <title>Edit | Offers Interests | Lara Capital</title>
        </Helmet>
        <div className="PageHeader">
          <div className="ContentLeft">
            <div className="Title">
              <h1>Offers Interests</h1>
            </div>
            <Breadcrumb>
              <li>
                <Link to="/">Dashboard</Link>
              </li>
              <li>
                <Link to="/statement-requests">Offers Interests</Link>
              </li>
              <li>Edit</li>
            </Breadcrumb>
          </div>
        </div>
        <div className="PageContent DataForm">
          <div className="ContentHeader">
            <div className="Title">
              <h1>Edit Offer Interest</h1>
            </div>
          </div>
          <div className="MainContent">
            <div className="FormContainer">
              {data ? (
                <>
                  <div className={styles.DetailOverview}>
                    <div className={styles.Detail}>
                      <div>User Name</div>
                      <div>{data.user.name}</div>
                    </div>
                    <div className={styles.Detail}>
                      <div>User ID</div>
                      <div>{data.user.user_id}</div>
                    </div>
                    <div className={styles.Detail}>
                      <div>Offer</div>
                      <div>{data.offer.title}</div>
                    </div>
                    <div className={styles.Detail}>
                      <div>Created At</div>
                      <div>
                        {moment(data.created_at).format("DD MMM YYYY, h:mm A")}
                      </div>
                    </div>
                    <div className={styles.Detail}>
                      <div>Updated At</div>
                      <div>
                        {data.updated_at
                          ? moment(data.updated_at).format(
                              "DD MMM YYYY, h:mm A"
                            )
                          : null}
                      </div>
                    </div>
                  </div>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                  >
                    {({ setFieldValue }) => {
                      return (
                        <Form>
                          <div
                            className={["FormBody", styles.FormBody].join(" ")}
                          >
                            <FormikControl
                              control="select"
                              label="Status *"
                              name="status"
                              options={statusOptions}
                              value={data.status}
                              setFieldValue={setFieldValue}
                            />
                          </div>

                          <div
                            className={["FormActions", styles.FormActions].join(
                              " "
                            )}
                          >
                            <Button
                              btnType="Primary"
                              type="Submit"
                              width="W100"
                              isLoading={this.state.isLoading}
                            >
                              Send
                            </Button>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </>
              ) : null}
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default Update;
